// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] || chunkId) + "." + {"271":"4748acd1","669":"8c9ed138","732":"6bfe6442","757":"c1178b24","779":"d24abef7","874":"87b89dbf"}[chunkId] + ".js";
};